import axios from "axios";
import { constants } from "../config";

const httpClient = axios.create({
  baseURL: `${constants.API_URL}/api/`,
});

export default httpClient;
